import {isRcsProject} from "@/utils";

const isRcs = isRcsProject()

export default [
    {
        to: "/backend", layout: "/sidebar", children: [
            {to: "/backend/dashboard", text: "首页", component: "dashboard"},

            //客户管理
            {to: "/backend/customer/list", text: "客户管理", component : "customer/list"},
            {to: "/backend/customer/recharge/:type", text: "客户充值/扣款", component : "finance/recharge"},
            {to: "/backend/customer/consume", text: "客户消耗", component : "finance/consume"},
            {to: "/backend/customer/remit", text: "客户汇款", component : "customer/remit"},
            {to: "/backend/customer/authentication", text: "客户认证", component : "customer/authentication"},
            {to: "/backend/customer/log", text: "登录日志", component : "customer/log"},

            //消息处理
            {to: "/backend/:product/message/task", component: 'message/list'},
            {to: "/backend/:product/message/detail/:batchId", component: 'message/detail'},
            {to: "/backend/:product/message/:filterType", component: 'message/list'},

            //产品 & 通道
            {to: "/backend/product/api", text: "接口管理", component : "channel/api"},
            {to: "/backend/product/list", text: "产品列表", component : "product"},


            {to: "/backend/setting/account", text: "账号管理", component : "setting/account"},
            {to: "/backend/setting/sms/template", text: "短信模板", component : "setting/sms/template"},
            {to: "/backend/setting/sms/record", text: "短信记录", component : "setting/sms/record"},
            {to: "/backend/setting/system", text: "系统设置", component : "setting/system"},
        ]
    },
    {to: isRcs ? "/backend/login" : "/system/login", component: isRcs ? "rcslogin" : "login", text: "系统登陆"}
]
